import { render } from "./district-list.vue?vue&type=template&id=76552f5a&scoped=true"
import script from "./district-list.vue?vue&type=script&lang=js"
export * from "./district-list.vue?vue&type=script&lang=js"

import "./district-list.vue?vue&type=style&index=0&id=76552f5a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76552f5a"]])

export default __exports__